




















import HealthProfessionalForm from '@/components/healthProfessional/HealthProfessionalForm.vue';
import HealthProfessionalUtils, {
  HealthProfessional,
} from '@/utils/HealthProfessionalUtils';
import Vue from 'vue';

export default Vue.extend({
  components: { HealthProfessionalForm },

  data(): {
    state: {
      valid: boolean;
      submit: boolean;
      errors?: any[];
    };
    item?: Partial<HealthProfessional>;
  } {
    return {
      state: {
        valid: false,
        submit: false,
        errors: undefined,
      },
      item: undefined,
    };
  },

  async mounted() {
    this.item = HealthProfessionalUtils.healthProfessional.generateDefault();
  },

  methods: {
    async handleSubmit() {
      if (this.item) {
        try {
          this.state.errors = undefined;
          this.state.submit = true;
          (this.$refs.form as any).validate();
          this.item = await HealthProfessionalUtils.api.create(this.item);
          (this.$refs.form as any).resetValidation();
          this.$toast.push({
            text: this.$t('success.create', [
              this.$tc('healthProfessional.label'),
            ]),
            type: 'success',
          });
          this.$router.replace({ name: 'health-professional-list' });
        } catch (error) {
          this.$toast.push({
            text: this.$t('error.create', [
              this.$tc('healthProfessional.label'),
            ]),
            type: 'error',
          });
          this.state.errors = error; // TODO: handle errors
        } finally {
          this.state.submit = false;
        }
      }
    },
  },
});
